import { GET_PROVIDER_LODGING_POLICY_FAILURE, GET_PROVIDER_LODGING_POLICY_REQUEST, GET_PROVIDER_LODGING_POLICY_SUCCESS, GET_PROVIDER_LODGING_POLICY_CLEAR, GetProviderLodgingPolicyActionTypes, GetProviderLodgingPolicyState } from './types';

const defaultState: GetProviderLodgingPolicyState = {
  isLoading: false,
  errorMessage: "",
};

export default function getProviderLodgingPolicy(state = defaultState, action: GetProviderLodgingPolicyActionTypes): GetProviderLodgingPolicyState {
  switch (action.type) {
    case GET_PROVIDER_LODGING_POLICY_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_PROVIDER_LODGING_POLICY_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_PROVIDER_LODGING_POLICY_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case GET_PROVIDER_LODGING_POLICY_CLEAR:
      return {
        ...state,
        isLoading: false,
        errorMessage: "",
        contents: undefined
      };
    default:
      return state;
  }
};
